import { Column, Table } from '@tanstack/react-table';
import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import PickerModal from '../facility/PickerModal';

export default function FacilitiesFilter({
  column,
  table,
}: {
  column: Column<any, unknown>
  table: Table<any>
}) {
  const [showPicker, setShowPicker] = useState(false);
  const [facilityIds, setFacilityIds] = useState<number[]>([]);
  const [first10SelectedNames, setFirst10SelectedNames] = useState<string[]>([]);

  const getSelectedNames = () => {
    if (facilityIds.length > 1) {
      return `${first10SelectedNames[0]} + ${facilityIds.length - 1}`;
    } else {
      return first10SelectedNames[0];
    }
  }

  return (
    <div>
      {showPicker &&
        <PickerModal
          selected={facilityIds}
          onClose={(facilityIds, facilityNames) => {
            setShowPicker(false);
            if (facilityIds) {
              setFacilityIds(facilityIds);
              setFirst10SelectedNames(facilityNames);
              column.setFilterValue(facilityIds);
            }
          }} />
      }

      <Form.Control
        type="text"
        size="sm"
        readOnly
        placeholder={facilityIds.length > 0 ? getSelectedNames() : 'Select facilities'}
        onClick={(e) => {
          setShowPicker(true);
          e.preventDefault();
        }}
        style={{ cursor: 'pointer' }} />
    </div>
  );
};
